var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMeatball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41856 11.8571C2.20754 11.8571 2.84713 11.2175 2.84713 10.4286C2.84713 9.63959 2.20754 9 1.41856 9C0.629583 9 -0.0100098 9.63959 -0.0100098 10.4286C-0.0100098 11.2175 0.629583 11.8571 1.41856 11.8571Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0108 11.8571C10.7998 11.8571 11.4394 11.2175 11.4394 10.4286C11.4394 9.63959 10.7998 9 10.0108 9C9.22182 9 8.58223 9.63959 8.58223 10.4286C8.58223 11.2175 9.22182 11.8571 10.0108 11.8571Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5613 11.8571C19.3503 11.8571 19.9899 11.2175 19.9899 10.4286C19.9899 9.63959 19.3503 9 18.5613 9C17.7724 9 17.1328 9.63959 17.1328 10.4286C17.1328 11.2175 17.7724 11.8571 18.5613 11.8571Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeatball);
export default __webpack_public_path__ + "static/media/icon-meatball.7e5f0f48ef1c50a0934909575e3010ad.svg";
export { ForwardRef as ReactComponent };